import { useEffect } from 'react';

export const useFreshdeskWidget = (widgetId: string) => {
  useEffect(() => {
    window.fwSettings = { widget_id: widgetId };

    if (typeof window.FreshworksWidget !== 'function') {
      const n = function () {
        (n as any).q.push(arguments);
      };
      (n as any).q = [];
      window.FreshworksWidget = n as any;
    }

    const script = document.createElement('script');
    script.src = `https://widget.freshworks.com/widgets/${widgetId}.js`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    setTimeout(() => {
      if (typeof window.FreshworksWidget === 'function') {
        try {
          window.FreshworksWidget('hide', 'launcher');
        } catch (e) {}
      }
    }, 1000);

    return () => {
      document.body.removeChild(script);
      const widgetContainer = document.getElementById('freshworks-widget-container');
      if (window.FreshworksWidget && widgetContainer) {
        try {
          window.FreshworksWidget('destroy');
        } catch (e) {
          console.error('Error destroying FreshworksWidget:', e);
        }
      }
    };
  }, [widgetId]);
};
